import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Users from '../views/usuarios.vue'
import UserList from '../views/usuariosList.vue'
import Perfil from '../views/perfil.vue'
import userAcount from '../views/miCuenta.vue'
import changePass from '../views/changePass.vue'
import editUser from '../views/editUser.vue'
import addUser from '../views/addUser.vue'
import addCsvUsers from '../views/addCsvUsers.vue'
import login from '../views/login.vue'
import RecoverPass from '../views/RecoverPass'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserCircle, faPowerOff, faLock, faEllipsisH, faPencilAlt, faTrashAlt } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(
  faUserCircle,
  faPowerOff,
  faLock,
  faEllipsisH,
  faPencilAlt,
  faTrashAlt
)

Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Usuarios',
    component: Home,
    meta: {
      breadcrumb: 'Inicio',
      requiresAuth: true

    },
    children: [
      {
        path: '/',
        name: 'Usuarios',
        component: Users,
        meta: {
          breadcrumb: 'Usuarios'
        },
        children: [
          {
            path: '/',
            name: 'Listado de usuarios',
            component: UserList,
            meta: {
              breadcrumb: 'Listado usuario'
            }
          },
          {
            path: '/edit-user',
            name: 'Editar usuario',
            component: editUser,
            meta: {
              breadcrumb: 'Editar usuario'
            }
          },
          {
            path: '/add-user',
            name: 'Crear usuario',
            component: addUser,
            meta: {
              breadcrumb: 'Crear usuario'
            }
          },
          {
            path: '/add-users',
            name: 'Carga Masiva Elearning',
            component: addCsvUsers,
            meta: {
              breadcrumb: 'Carga masiva Elearning'
            }
          }
        ]
      },
      {
        path: '/user',
        name: 'Perfil',
        component: Perfil,
        meta: {
          breadcrumb: 'Mi cuenta',
          requiresAuth: true
        },
        children: [
          {
            path: '/',
            name: 'Mi cuenta',
            component: userAcount
          },
          {
            path: '/change-pass',
            name: 'Cambiar contraseña',
            component: changePass,
            meta: {
              breadcrumb: 'Cambiar contraseña'
            }
          }
        ]
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: login,
    meta: {
      breadcrumb: 'Login',
      requiresAuth: false
    }
  },
  {
    path: '/contrasena',
    name: 'Recuperar contraseña',
    component: RecoverPass,
    meta: {
      breadcrumb: 'Recuperar contraseña',
      requiresAuth: false
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(route => route.meta.requiresAuth)) {
    const storageAuth = localStorage.getItem('token')
    if (storageAuth === '') {
      return next({ path: '/login' })
    }
    sessionStorage.setItem('rtta', to.fullPath)
    return next()
  }
  return next()
}
)

export default router
